export const navigateToUrl = (url) => {
    const currentUrl = new URL(window.location.href);
    let targetUrl = url;
    if (url.startsWith('#')) {
        currentUrl.hash = url;
        targetUrl = currentUrl.toString();
    }
    else if (url.startsWith('/')) {
        targetUrl = currentUrl.protocol + '//' + currentUrl.hostname + url;
    }
    window.location.href = targetUrl;
};
